import { useContext, useState } from 'react';
import { store } from 'components/Store';
import { useContentResults } from 'components/Dashboard/ContentResultsContext';
import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';
import { useParams } from 'react-router';

const useAddTagsToStakeholder = (props) => {
  const { customContact } = props ?? {};
  const globalState = useContext(store);
  const { state, dispatch } = globalState;
  const { contentResults, setContentResults } = useContentResults();
  const { customContactInfo } = state;

  const params = useParams();
  const { id } = params;
  const { Stakeholders } = contentResults ?? {};
  const Stakeholder = Stakeholders?.contact;

  const { generalApiCall } = useGeneralApiCall();
  const [tags, setTags] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const addTagsToStakeholder = async (closeModal, newTags) => {
    setIsLoading(true);
    const pathname = '/api/crm-contact/update';
    const method = 'post';
    let requestProperties;
    if (customContact) {
      const tagsToUpdate = newTags ?? [...customContactInfo?.tags, ...tags.map((tag) => tag.value)];
      requestProperties = {
        id,
        tags: tagsToUpdate.length === 0 ? null : tagsToUpdate,
      };
    } else {
      const tagsToUpdate = newTags ?? [...Stakeholder?.contactInformation?.[0]?.tags, ...tags.map((tag) => tag.value)];
      requestProperties = {
        id: Stakeholder?.contactInformation?.[0]?.id,
        tags: tagsToUpdate.length === 0 ? null : tagsToUpdate,
      };
    }
    const results = await generalApiCall({ pathname, method, requestProperties, needsAuthentication: true });
    if (results !== undefined) {
      if (customContact) {
        dispatch({ type: 'MODIFY_SECTION', parameter: 'customContactInfo', value: results });
      } else {
        setContentResults({
          ...contentResults,
          Stakeholders: {
            ...Stakeholders,
            contact: {
              ...Stakeholders?.contact,
              contactInformation: [results],
            },
          },
        });
      }

      if (closeModal) {
        closeModal();
      }
    }
  };
  return { tags, setTags, isLoading, addTagsToStakeholder };
};

export default useAddTagsToStakeholder;
